import axios from 'axios'
// import store from '@/store/index'
// import Vue from 'vue'

// 生产环境prod
const API_URL = 'https://api.wisroom.100tal.com/nzoth-org/v5/teacher'

// 测试环境test
// const API_URL = 'https://api1.wisroomtest.100tal.com/nzoth-org/v5/teacher'

// 本地环境
// const API_URL = 'http://10.33.33.92:8875/nzoth-org/v5/teacher'

const Axios = axios.create({
  // withCredentials: true,
  timeout: 10000
})

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = API_URL
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = API_URL
}

Axios.interceptors.request.use(config => {
  return config
})

Axios.interceptors.response.use(res => {
  // 返回拦截data里有data、headers、status
  return res
})

export default {
  install: function (Vue, Option) {
    Object.defineProperty(Vue.prototype, '$axios', { value: Axios })
  }
}
